import { ref} from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm} from 'vee-validate'
import {generaPackingListSchema} from '@/schemas/batchSchema'

export const useGeneratePackingList = (): any => {
    const { values, handleSubmit, errors, setErrors, resetForm, meta} = useForm({
        validationSchema: toTypedSchema(generaPackingListSchema)
    })
    const toast = useToast()
    const generatePackingListLoading = ref(false)

    const showToast = (type: 'success' | 'error', title: string, message: string) => {
        toast.add({
            severity: type,
            summary: title,
            detail: message,
            life: 5000
        })
    }

    return { values, handleSubmit, errors, setErrors, resetForm, meta, generatePackingListLoading, showToast }
}